<template>
  <section id="HomeAboutSection" ref="MainContent">
    <div class="main_container">
      <div class="image_box">
        <img
          :src="
            $store.getters.imageUrl(
              $store.getters.columnData('home_about_image')
            )
          "
        />
      </div>
      <div class="text_box">
        <header>
          <h3 data-section-title>
            {{ $store.getters.columnData("home_about_title") }}
          </h3>
        </header>
        <div class="content textarea_content" data-section-content>
          {{ $store.getters.columnData("home_about_content") }}
        </div>

        <div class="action_box" data-section-content>
          <router-link to="/shop_info" class="main_button"
            >門市資訊
            <span class="icon material-symbols-rounded"> east </span>
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { CoverSection } from "@/animations/home/aboutSection.js";
export default {
  name: "HomeAboutSection",
  data() {
    return {
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new CoverSection(this.$refs.MainContent);
      this.animation.Reset();
    },
    SetAnimation() {
      // this.animation.Setup();
    },
  },
  mounted() {
    // this.InitAnimation();
  },
};
</script>
